import type {SupportedBypassMode} from '../bypass-actors-types'

import {UNSUPPORTED_BYPASS_MODES_BY_ACTOR_TYPE} from './constants'

/** Drop the modes that the given actor type does not support. */
export function filterSupportedModes(
  actorType: string,
  supportedBypassModes: SupportedBypassMode[],
): SupportedBypassMode[] {
  return supportedBypassModes.filter(mode => !UNSUPPORTED_BYPASS_MODES_BY_ACTOR_TYPE[actorType]?.includes(mode.mode))
}
